import { render } from "./Index.vue?vue&type=template&id=3ff7474e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=3ff7474e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3ff7474e"

export default script